import React from 'react'

const PinkCard = ({children}) => (
  <div className='pink-card' style={{padding: 36, borderRadius: 36, border: 'none', background: '#ee5da1', color: '#FFF', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'top'}}>
    {children}
  </div>
)

export default PinkCard
